// Example vehicle data for VehicleShowcase component
// Add this to your siteConfig.js or create a separate data file

export const vehicleData = [
    {
        model: 'Audi R8',
        power: 90,
        torque: 120,
        image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80'
    },
    {
        model: 'BMW M4',
        power: 75,
        torque: 100,
        image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&q=80'
    },
    {
        model: 'Mercedes AMG',
        power: 85,
        torque: 110,
        image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&q=80'
    },
    {
        model: 'Porsche 911',
        power: 95,
        torque: 130,
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80'
    },
    {
        model: 'BMW M3',
        power: 80,
        torque: 105,
        image: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&q=80'
    },
    {
        model: 'Audi RS6',
        power: 70,
        torque: 95,
        image: 'https://images.unsplash.com/photo-1614200187524-dc4b892acf16?w=800&q=80'
    }
];